import type { IAccount } from "@/modules/account/common/types";
import { Amount } from "@/shared/components";
import { Copy } from "@ab.uitools/ui-library/components/Copy";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { Text } from "@ab.uitools/ui-library/components/Text";
import type { RefObject } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  account?: IAccount;
  scrollbarContainerRef?: RefObject<HTMLDivElement | null>;
}

export const AccountDetailRows = ({
  account,
  scrollbarContainerRef
}: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <div>
        <div>
          <div className="flexbox justify-content--between pb-20 detail-row">
            <Text type="secondary" size="medium" weight="semibold">
              {t("accounts.accountType")}
            </Text>
            <Text size="medium" weight="bold">{account?.description}</Text>
          </div>
          <Divider
            color="light"
            type="primary"
            isHorizontal
          />
        </div>
        <div className="flexbox justify-content--between pt-20 pb-20 detail-row">
          <Text type="secondary" size="medium" weight="semibold">
            {t("accounts.accountNumber")}
          </Text>
          <div className="flexbox align-items--center">
            <Copy
              textAfterCopy={t("general.copied")}
              size="medium"
              parentRef={scrollbarContainerRef as RefObject<HTMLDivElement>}
              text={account?.number as string}
            />
            <Text size="medium" weight="bold">{account?.number}</Text>
          </div>
        </div>
        <Divider
          color="light"
          type="primary"
          isHorizontal
        />
      </div>
      <div>
        <div className="flexbox justify-content--between pt-20 pb-20 detail-row">
          <Text type="secondary" size="medium" weight="semibold">
            {t("accounts.balance")}
          </Text>
          <Amount currency={account?.currency} amount={account?.balance as number}/>
        </div>
        <Divider
          color="light"
          type="primary"
          isHorizontal
        />
      </div>
      <div>
        <div className="flexbox justify-content--between pt-20 pb-20 detail-row">
          <Text type="secondary" size="medium" weight="semibold">
            {t("accounts.currentBalance")}
          </Text>
          <Amount currency={account?.currency} amount={account?.expectedBalance as number}/>
        </div>
        <Divider
          color="light"
          type="primary"
          isHorizontal
        />
      </div>
    </div>
  );
};
